/**
 * LEARNING-ROUTE
 */
import NavApp from "@/nav/nav.app"
import LearningHomeWidget from "@/widgets/learning-home.widget"

function LearningRoute() {
  return (
    <NavApp>
      <LearningHomeWidget />
    </NavApp>
  )
}

export default LearningRoute
